"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardSummary = void 0;
const React = require("react");
const react_1 = require("react");
const _ = require("lodash");
const Button_1 = require("../../atoms/Button");
const CreditCardModal_1 = require("../../modals/CreditCardModal");
const creditCardIsExpired_1 = require("../../../../helpers/creditCardIsExpired");
const Badge_1 = require("../../atoms/Badge");
const Message_1 = require("../../atoms/Message");
const Resource_1 = require("../../atoms/Resource");
const VStack_1 = require("../../structure/VStack");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const styles = require("./styles.scss");
const css = (0, cssComposer_1.default)(styles, "CreditCard");
/**
 * Renders a credit card summary.
 */
const CreditCardSummary = ({ card, onSetCard, disclaimer }) => {
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const handleOnSuccess = (0, react_1.useCallback)(data => {
        onSetCard(data);
        setIsModalOpen(false);
    }, []);
    const ccExpired = (0, react_1.useMemo)(() => (0, creditCardIsExpired_1.creditCardIsExpired)(card), [card]);
    if (!_.get(card, "cardNumberLast4")) {
        return onSetCard ? (React.createElement(React.Fragment, null,
            React.createElement("span", { "data-test": "setCard" },
                React.createElement(Button_1.Button, { onClick: () => setIsModalOpen(true) }, "Add a card")),
            React.createElement(CreditCardModal_1.CreditCardModal, { onSuccess: handleOnSuccess, open: isModalOpen, onClose: () => setIsModalOpen(false), disclaimer: disclaimer }))) : null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Resource_1.Resource, null,
            React.createElement(Resource_1.ResourceBody, null,
                React.createElement(VStack_1.VStack, null,
                    React.createElement("div", { className: css("") },
                        React.createElement("label", { className: css("type") }, card.cardType),
                        " ",
                        React.createElement("span", { className: css("number") },
                            "XXXX XXXX XXXX ",
                            card.cardNumberLast4),
                        React.createElement("span", { className: css("expiry") }, !!card.expirationDate &&
                            (ccExpired ? (React.createElement(Badge_1.DangerBadge, { icon: "warning", size: "sm" },
                                "Exp. ",
                                card.expirationDate)) : (React.createElement("small", null,
                                "Exp. ",
                                card.expirationDate)))),
                        " ",
                        !!onSetCard && (React.createElement("span", { "data-test": "changeCard" },
                            React.createElement(Button_1.Button, { className: css("edit"), onClick: () => setIsModalOpen(true) }, "Edit")))),
                    ccExpired && (React.createElement(Message_1.ErrorMessage, null, "Your credit card has expired. Please update your card details."))))),
        React.createElement(CreditCardModal_1.CreditCardModal, { onSuccess: handleOnSuccess, open: isModalOpen, onClose: () => setIsModalOpen(false), disclaimer: disclaimer })));
};
exports.CreditCardSummary = CreditCardSummary;
//# sourceMappingURL=index.js.map